var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgIcLinkinline = function SvgIcLinkinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.386 12.494a1.92 1.92 0 00-2.722 0l-2.86 2.86a1.92 1.92 0 000 2.722 1.92 1.92 0 002.722 0l2.53-2.53a.5.5 0 01.708.708l-2.53 2.53a2.92 2.92 0 01-4.138 0 2.92 2.92 0 010-4.138l2.86-2.86a2.92 2.92 0 014.722.843.5.5 0 01-.916.402 1.761 1.761 0 00-.376-.537z",
    fill: "#121E6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.006 7.874a1.92 1.92 0 00-2.722 0l-2.62 2.62a.5.5 0 01-.708-.708l2.62-2.62a2.92 2.92 0 014.138 0 2.92 2.92 0 010 4.138l-2.86 2.86a2.92 2.92 0 01-4.681-.75.5.5 0 11.894-.448c.086.171.204.338.357.49a1.92 1.92 0 002.722 0l2.86-2.86a1.92 1.92 0 000-2.722z",
    fill: "#121E6C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.16 2C5.516 2 5 2.516 5 3.16v17.7c0 .644.516 1.16 1.16 1.16h7.96c.644 0 1.16-.516 1.16-1.16v-7.25a.5.5 0 011 0v7.25c0 1.196-.964 2.16-2.16 2.16H6.16A2.156 2.156 0 014 20.86V3.16C4 1.964 4.964 1 6.16 1h7.95c1.196 0 2.16.964 2.16 2.16V4.9a.5.5 0 01-1 0V3.16c0-.644-.516-1.16-1.16-1.16H6.16z",
    fill: "#121E6C"
  })));
};
export default SvgIcLinkinline;